import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";

import { API } from "@/lib/api";
export function useGalleryPhotos() {
  const [photos, setPhotos] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/gallery`);
      setPhotos(data || []);
      return true;
    } catch {
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { photos, refresh };
}
